import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material';
import { AELAdhesionDTO } from "@com.sofaxis/sofaxis-fonpel-espace-elus-ws-ts/dist";

export enum ResultatEligibilite {
  Eligible,
  NonEligible,
};

@Component({
  selector: 'app-recueil-besoin-form',
  templateUrl: './recueil-besoin-form.component.html',
  styleUrls: ['./recueil-besoin-form.component.scss']
})
export class RecueilBesoinFormComponent implements OnInit {
  private resultToShow : ResultatEligibilite;
  public formGroup!: FormGroup;
  // Injection à faire ?
   @ViewChild('recueilStepper')  private recueilStepper : MatStepper;
  public recueildone = false;
  @Input() initialAdhesion: AELAdhesionDTO;
    @Input() provenanceExterne: boolean;

  @Output() childStepperComplete = new EventEmitter<void>();

  constructor(private _formBuilder: FormBuilder) { }

  ngOnInit() {
    const reprise = this.initialAdhesion.adherent != null && (this.initialAdhesion.idDeTransfertPourSauvegarde != null || this.initialAdhesion.idEnveloppeDocusign != null)
    this.formGroup = this._formBuilder.group({
      indemnise: [reprise == false ? null : true, Validators.required],
      regimeRetraite: [reprise == false ? null : true, Validators.required],
      contratsAssurance:[this.initialAdhesion.contratsAssuranceExistant]
    });


  }

  isCompletedAndValid() {
    return this.recueildone && this.formGroup.value.indemnise == true && this.formGroup.value.regimeRetraite == true;
  }

  ngAfterViewInit() {
    //si déjà adhérent on skip ce step
    if(!this.provenanceExterne) {
        Promise.resolve().then(() => {
        this.formGroup.patchValue({
          indemnise: true,
          regimeRetraite: true,
          contratsAssurance: this.initialAdhesion.contratsAssuranceExistant
        });
        this.recueilStepper.selectedIndex = 2;
        this.newAdhesion();   
        });
    }
  }


    resultatEligibilite() {
      // Si 2 « OUI » aux 2ères questions
      if(this.formGroup.value.indemnise
        && this.formGroup.value.regimeRetraite
      ) {
         this.resultToShow = ResultatEligibilite.Eligible;
        return;
      }
  
      // Si oui à 1 mais non à 2
      if(this.formGroup.value.indemnise
        && !this.formGroup.value.regimeRetraite) {
        this.resultToShow = ResultatEligibilite.NonEligible;
        return;
      }
  
      // Si non à tout (Reste)
      this.resultToShow = ResultatEligibilite.NonEligible;
    }
    
    newAdhesion() {
      //this.initialAdhesion.recueilBesoin.eluIndemnise = this.formGroup.value.indemnise; --> forcément TRUE
      //this.initialAdhesion.recueilBesoin.regimeRetraite = this.formGroup.value.regimeRetraite; --> forcément TRUE
      if(this.formGroup.value.indemnise && this.formGroup.value.regimeRetraite) {
        if(this.initialAdhesion == null) {
          this.initialAdhesion = {};
          this.initialAdhesion.adherent = {};
          this.initialAdhesion.collectivite = {};
          this.initialAdhesion.beneficiaires = [];
        }
        this.initialAdhesion.contratsAssuranceExistant = this.formGroup.value.contratsAssurance;
        this.recueildone = true;
        this.childStepperComplete.emit(); // Notify parent stepper to move on
      }
    }

    onCompleteSteps() {
      this.currentStepIndex = 1;
      this.recueilStepper.selectedIndex = 1;
      this.recueildone = false;
      console.log("On complete steps");
    }
  
    showEligiblite() {
      return this.resultToShow == ResultatEligibilite.Eligible;
    }
  
  
    showNonEligibile() {
      return this.resultToShow == ResultatEligibilite.NonEligible;
    }
    currentStepIndex = 0;

    onStepChange(event: any) {
      this.currentStepIndex = event.selectedIndex;
    }

      // Optional: return a dynamic title based on step index
  getStepTitle(): string {
    switch (this.currentStepIndex) {
      case 0: return 'Recueil du besoin';
      case 1: return 'Je déclare que';
      case 2: return 'Notre recommandation';
      default: return '';
    }
  }

}
